export const PUBLIC_PATHS = {
    HOME: '/',
    LOGIN: '/login',
    SIGNUP: '/signup',
    
  };
  
   export const PRIVATE_PATHS = {
    DASHBOARD:"/dashboard",
    SECTIONS:'/sections',
    COURSES:'/courses',
    SECTIONS_INNER : '/sections/:id',
    STUDENTS:'/students',
    STUDENT:"/students/:id",
    ADD_SECTION:'/addSection',
    EDIT_SECTION:'/editSection/:id',
    INSTRUCTORS:"/instructors",
    INSTRUCTOR_PROFILE:'/instructor'
  };
  